import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContextTest'
import { Layout } from './components'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import Roles from './pages/Roles'
import Companies from './pages/Companies'
import CompanyPreview from './pages/CompanyPreview'
import Customers from './pages/Customers'
import Measurements from './pages/Measurements'
import MeasurementPreview from './pages/MeasurementPreview'
import Stock from './pages/Stock'
import StockTransactions from './pages/StockTransactions'
import Employees from './pages/Employees'
import Orders from './pages/Orders'
import Payments from './pages/Payments'
import Expenses from './pages/Expenses'
import Accounts from './pages/Accounts'
import BankDetails from './pages/BankDetails'
import Products from './pages/Products'
import Profile from './pages/Profile'
import Invoices from './pages/Invoices'
import { LoadingSpinner } from './components'

function App() {
  const { user, loading } = useAuth()

  console.log('App render - user:', user, 'loading:', loading)
  console.log('App render - user type:', typeof user, 'user value:', user)
  console.log('App render - loading type:', typeof loading, 'loading value:', loading)

  if (loading) {
    console.log('App: Showing loading spinner')
    return <LoadingSpinner />
  }

  if (!user) {
    console.log('App: No user, redirecting to login')
    console.log('App: user is falsy:', !user)
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  console.log('App: User authenticated, showing dashboard')

  return (
    <Layout>
        <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        
        {/* User Management */}
        <Route path="/users" element={<Users />} />
        <Route path="/roles" element={<Roles />} />
        
        {/* Company Management */}
        <Route path="/companies" element={<Companies />} />
        <Route path="/companies/:id" element={<CompanyPreview />} />
        
        {/* Customer Management */}
        <Route path="/customers" element={<Customers />} />
        <Route path="/measurements" element={<Measurements />} />
        <Route path="/measurements/:id" element={<MeasurementPreview />} />
        
        {/* Inventory Management */}
        <Route path="/stock" element={<Stock />} />
        <Route path="/stock-transactions" element={<StockTransactions />} />
        
        {/* Employee Management */}
        <Route path="/employees" element={<Employees />} />
        
        {/* Order Management */}
        <Route path="/orders" element={<Orders />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/invoices" element={<Invoices />} />
        
        {/* Product Management */}
        <Route path="/products" element={<Products />} />
        
        {/* Financial Management */}
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/bank-details" element={<BankDetails />} />
        
        {/* Profile */}
        <Route path="/profile" element={<Profile />} />
        
        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
